import httpClient from './httpClient';

export default {
    getById: (id) => {
        return httpClient.get(`/api/HealthChecks/${id}?code=-gtVD9Nkr5z0JbyS6cQ3CSPHYyGNNqS9cJwB0wPaU7pxAzFujxLxHg==`)
            .then(resp => resp.data);
    },
    createHealthCheck: (healthCheck) => {
        return httpClient.post(`/api/HealthChecks/?code=3_ODBRS6iu_ZoP7KzCses9FjX52j09yVhrbGLLs5S5W0AzFuqAGa_w==`, healthCheck)
            .then(resp => resp.data);
    },
};